import styled from 'styled-components';

export const SearchbarWrapper = styled.div`
  display: flex;
  align-items: self-start;
  gap: .5em;
  dsy-card {
    flex-grow: 1;
  }

  ${(props) => props.isMobile && `
    #searchbarAccordionBtn,
    #templateManagementBtn, 
    #searchbarLoadedFiltersHDivider, 
    #searchbarLoadedFiltersVDivider, 
    #searchbarFullSizeSubmitBtn {
      display: none;
    }

    #searchbarLoadedFilters > div {
      justify-content: center;
    }

    #searchbarInnerManagementBtn {
      display: block !important;
    }

    #searchbarVisibleFiltersColumn {
      width: auto;
    }

    #searchbarXSSubmitBtn {
      display: block !important;
    }

    #searchbarResetFilters {
      width: 100%;
      margin-top: 1em;
    }

    #searchbarResetFilters > div {
      flex-direction: column;
    }

    #searchbarResetFilters dsy-button {
      margin: 0 auto;
    }
  `}
`;

export default SearchbarWrapper;
